import { IntercomProvider } from "react-use-intercom";
import { INTERCOM_APP_ID } from "../../config";
import { ContactUsIntercom } from "./ContactUsIntercom";

const ContactUs = () => {
  if (INTERCOM_APP_ID) {
    return (
      <IntercomProvider appId={INTERCOM_APP_ID} autoBoot>
        <ContactUsIntercom />
      </IntercomProvider>
    );
  }

  return null;
};

export { ContactUs };
